import React from "react";
import styled from "styled-components";
import {
  Link,

  // useRouteMatch
} from "react-router-dom";
import { useDispatch } from "react-redux";
import { Section, Grid, Typography, Button } from "../../core";
import { theme, MixStyle, media } from "../../styles";
import { updateCurrentPath } from "../../redux/Action/pageRoot";

const { textColor, buttonBg } = theme;
const typoProps = {
  align: "center",
  as: "h2",
  weight: "800",
  color: textColor.primary,
};
const StyledSection = styled(Section)`
  margin: 50px auto;
  min-height: 341px;
  ${MixStyle.flexCenter};
  flex-direction: column;
`;
const BtnWraper = styled.div`
  ${MixStyle.flexCenter};
  ${media.minitablet`display:block;`}
  flex-flow: row wrap;
  a {
    font-weight: bold;
    font-size: 24px;
    line-height: 36px;
  }
  Button {
    ${media.minitablet`margin:auto;`}
  }
`;
const AddContract = () => {
  const dispatch = useDispatch();
  dispatch(updateCurrentPath("Add Contract"));
  // let { path, url } = useRouteMatch();
  return (
    <Grid>
      <StyledSection maxwidth="580px">
        <Typography {...typoProps} text="Select Contract Type" />
        <BtnWraper>
          <Button width="187px" margin="10px" bg={buttonBg.primary}>
            <Link to={`/fabric-contract`}>Fabric</Link>
          </Button>
          <Typography {...typoProps} noMargin text="Or" />
          <Button width="187px" margin="10px" bg={buttonBg.primary}>
            <Link to="conversion-contract">Conversion</Link>
          </Button>
        </BtnWraper>
      </StyledSection>
    </Grid>
  );
};

export default AddContract;
